import { Pressable, StyleSheet, Text, View } from "react-native";
import React, { useState } from "react";
import { fp, spH, spV } from "utils/normalise";

import { Colors } from "colors";
import VText from "./VText";
import { useSelector } from "react-redux";
import { Link } from "expo-router";
const PopupMenu = ({ options, onSelect, visible = false }) => {
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const _closetModalRef = useSelector(
    (state) => state.UtilsReducer._closetModalRef
  );
  const _outfitModalRef = useSelector(
    (state) => state.UtilsReducer._outfitModalRef
  );
  const userProfile = useSelector((state) => state.ProfileReducer.profileData);
  const homeData = useSelector((state) => state.HomeReducer.homeData);

  const handlePress = (option) => {
    switch (option?.title) {
      case "Digital Closet":
        _closetModalRef?.current?.show();
        break;
      case "Outfit":
        _outfitModalRef?.current?.show();
        break;
      default:
        onSelect(option);
    }
  };

  return (
    <View style={styles.menuContainer}>
      {options &&
        options.map((option, index) => {
          if (option?.title === "For You") {
            if (
              userProfile?.isPreferences === false ||
              userProfile?.isPreferences === null ||
              userProfile?.isPreferences === undefined
            ) {
              return null;
            }
          }

          if (option?.url) {
            return (
              <Link
                aria-label={option?.title}
                key={index}
                style={[styles.menuItem]}
                onMouseEnter={() => setHoveredIndex(index)}
                onMouseLeave={() => setHoveredIndex(null)}
                href={option?.url || "#"}
                disabled={option?.url ? false : true}
                // onPress={() => handlePress(option)}
              >
                <VText
                  style={[
                    styles.menuItemText,
                    hoveredIndex === index && styles.menuItemHover,
                  ]}
                >
                  {option?.title}
                </VText>
              </Link>
            );
          } else {
            return (
              <Pressable
                key={index}
                style={[styles.menuItem]}
                onHoverIn={() => setHoveredIndex(index)}
                onHoverOut={() => setHoveredIndex(null)}
                onPress={() => handlePress(option)}
              >
                <VText
                  style={[
                    styles.menuItemText,
                    hoveredIndex === index && styles.menuItemHover,
                  ]}
                >
                  {option?.title}
                </VText>
              </Pressable>
            );
          }
        })}
    </View>
  );
};

const styles = StyleSheet.create({
  menuContainer: {
    display: "flex",
    position: "absolute",
    paddingHorizontal: 100,
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: Colors.white,
    paddingHorizontal: spH(15),
    paddingVertical: spV(5),
    // width: spH(145),
    // minWidth: spH(40),
    shadowColor: Colors.black30,
    shadowOffset: {
      width: 0,
      height: 0,
    },
    shadowOpacity: 0.65,
    shadowRadius: 5,
  },
  menuItem: {
    paddingVertical: 5,
    minWidth: spH(165),
    justifyContent: "center",
    alignItems: "center",
  },
  menuItemText: {
    fontSize: fp(14),
    width: "100%",
    fontFamily: "JosefinSans",
    fontWeight: "300",
    color: "#00000",
  },
  menuItemHover: {
    fontSize: fp(14),
    fontFamily: "JosefinSans",
    fontWeight: "450",
    color: "#000",
  },
});

export default PopupMenu;
